import { TicketStatusHistory } from "../../types";

export function hasStatus(statusList: TicketStatusHistory[], statusesToBeChecked: string[]): boolean {
  const existingStatuses = statusList.map((item) => item.status);
  return statusesToBeChecked.every((status) => existingStatuses.includes(status));
}
